import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import BrianyCareLogo from "../../assets/auth/BrainyCare-Logo.jpg";
import axios from "axios";
import CheckIcon from '@mui/icons-material/Check';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import IndeterminateCheckBoxIcon from '@mui/icons-material/CheckBox';
import DrMadhuSign from "../../assets/imaging/madhusign.png";
import { allowedUsers } from '../allowedUsers';
import { getPracticeId } from '../../config/practice';

const VenousView = () => {
  const { filename } = useParams();
  const [examData, setExamData] = useState(null);
  const conditions = ['spontaneous', 'phasic', 'augmented', 'competent', 'nonPulsatile', 'compression'];
  const regions = ['commonFemoral', 'superficialFemoral', 'popliteal', 'posteriorTibial', 'peroneal', 'greaterSaphenous'];
  const technicianComments = examData?.technicianComments || {};
  // const technicianComments = [
  //   { id: 1, label: '', options: [ 'NO DEEP VEIN THROMBOSIS'] },
  //   { id: 2, label: '', options: [ 'ALL VENIE ARE NORMALLY COMPRESSED'] },
  //   { id: 3, label: '', options: [ 'GOOD AUGMENTATION'] },
  //   { id: 4, label: '', options: [ 'NO REFLUX'] },
  //   { id: 5, label: '', vlaue: '' },
  //   { id: 6, label: '', vlaue: '' }

  //  ];

  // Fetch data from API
  const fetchData = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/v1/${getPracticeId()}/imaging/get-image/id`,
        { row_id: parseInt(filename, 10) }
      );

      if (response?.data?.data[0]) {
        const raw = response.data?.data[0];
        const parsedData = JSON.parse(raw.data);
        setExamData(parsedData);
      }
    } catch (error) {
      console.error("Error fetching exam data:", error);
    }
  };

  useEffect(() => {
    if (filename) fetchData();
  }, [filename]);


  
  return (
    <div id={examData ? "report-ready" : undefined} className="p-6 bg-white min-h-screen w-full flex justify-center items-center">
      <div className="w-full max-w-4xl flex flex-col border border-gray-300 rounded-md p-8 shadow-sm bg-white">
        {/* Header */}
<div className="flex items-center w-full justify-center">
  {/* Logo */}
  <img
    src={BrianyCareLogo}
    alt="Center for Hypertension & Internal Medicine"
    className="w-16 h-16 mr-4 flex-shrink-0"
  />

  {/* Text Content */}
  <div className="text-left">
    <h1 className="text-[1.5rem] font-semibold leading-tight">
      CENTER FOR HYPERTENSION <br/>& INTERNAL MEDICINE
    </h1>
  </div>
</div>
  <div className="text-center mb-6">
    <p className="text-sm font-medium mt-1">807 N Hancock Ave, Odessa, TX 79761</p>
    <p className="text-sm font-medium mt-1">Ph: 432-582-2446 &nbsp;|&nbsp; Fax: 432-582-2960</p>
  </div>


        {/* Title */}
        <h2 className="text-center font-bold text-base mb-4">VENOUS</h2>

        {examData ? (
          <>
            {/* Render Patient Info */}
            <div className="flex justify-start text-sm text-left w-full mb-1">
              <div className="grid grid-cols-[auto_20px_1fr] gap-x-2 gap-y-1">
                <span><strong>MR No#</strong></span><span>:</span><span>{examData.patient_id}</span>
                <span><strong>Name</strong></span><span>:</span><span>{examData.pat_name}</span>
                <span><strong>Age</strong></span><span>:</span><span>{examData.pat_age}</span>
                <span><strong>Exam Date</strong></span><span>:</span><span>{dayjs(examData.examDate).format("MM, DD, YYYY")}</span>
                <span><strong>Date of Birth</strong></span><span>:</span><span>
                  {dayjs(examData.pat_dob).format("MMM D, YYYY")}
                </span>
                <span><strong>Patients History</strong></span><span>:</span><span>{examData.pathistory}</span>
                <span><strong>Swelling</strong></span><span>:</span><span>{examData.swelling}</span>
              </div>
            </div>

            {/* Form data view */}
            <div className="w-full text-start mb-1 text-sm">
              <div className="grid grid-cols-2">
                <div className="mt-2"><strong>Take:</strong> {examData.take || ''}</div>
                <div className="mt-2"><strong>Tape:</strong> {examData.tape || ''}</div>
              </div>
              <div className="grid grid-cols-2">
                <div className="mt-2"><strong>Requested by:</strong> {examData.requestedby || ''}</div>
                <div className="mt-2"><strong>Technician:</strong> {examData.technician || ''}</div>
              </div>
              <div className="">
                <div className="mt-2"><strong>Patient History:</strong> {examData.pathistory || ''}</div>
                <div className="mt-2"><strong>TechSWELLINGnician:</strong> {examData.swelling || ''}</div>
              </div>
            </div>


{/* Table with Checkboxes */}
<div className="mb-8">
  <table className="table-auto w-full border-separate border-spacing-0 border border-gray-300">
  <thead>
    <tr className="bg-blue-100">
      <th className="px-2 py-1 text-sm bg-blue-100"></th> {/* Empty header for alignment */}
        <th key="Common Femoral" className="px-2 py-1 text-center text-sm bg-blue-100" colSpan={2}>
          Common Femoral
        </th>
        <th key="Superficial Femoral" className="px-2 py-1 text-center text-sm bg-blue-100" colSpan={2}>
          Superficial Femoral
        </th>
        <th key="Popliteal" className="px-2 py-1 text-center text-sm bg-blue-100" colSpan={2}>
          Popliteal
        </th>
        <th key="Posterior Tibial" className="px-2 py-1 text-center text-sm bg-blue-100" colSpan={2}>
          Posterior Tibial
        </th>
        <th key="Peroneal" className="px-2 py-1 text-center text-sm bg-blue-100" colSpan={2}>
          Peroneal
        </th>
        <th key="GreaterSaphenous" className="px-2 py-1 text-center text-sm bg-blue-100" colSpan={2}>
          Greater Saphenous
        </th>
    </tr>
    <tr className="bg-blue-200">
      <th className="px-2 py-1 text-sm bg-blue-100"></th> {/* Empty header for alignment */}
          <th key="CommonFemoralR" className="px-2 py-1 text-center text-sm bg-blue-100">R</th>
          <th key="CommonFemoralL" className="px-2 py-1 text-center text-sm bg-blue-100">L</th>
          <th key="Superficial FemoralR" className="px-2 py-1 text-center text-sm bg-blue-100">R</th>
          <th key="Superficial FemoralL" className="px-2 py-1 text-center text-sm bg-blue-100">L</th>
          <th key="PoplitealR" className="px-2 py-1 text-center text-sm bg-blue-100">R</th>
          <th key="PoplitealL" className="px-2 py-1 text-center text-sm bg-blue-100">L</th>
          <th key="Posterior TibialR" className="px-2 py-1 text-center text-sm bg-blue-100">R</th>
          <th key="Posterior TibialL" className="px-2 py-1 text-center text-sm bg-blue-100">L</th>
          <th key="PeronealR" className="px-2 py-1 text-center text-sm bg-blue-100">R</th>
          <th key="PeronealL" className="px-2 py-1 text-center text-sm bg-blue-100">L</th>
          <th key="GreaterSaphenousR" className="px-2 py-1 text-center text-sm bg-blue-100">R</th>
          <th key="GreaterSaphenousL" className="px-2 py-1 text-center text-sm bg-blue-100">L</th>
    </tr>
  </thead>
<tbody>
  {conditions.map((condition) => (
    <tr key={condition}>
      <td className="border px-2 py-1 text-center">
        {condition.charAt(0).toUpperCase() + condition.slice(1)}
      </td>
      {regions.map((region) => (
        <React.Fragment key={region}>
          <td className="border px-2 py-1 text-center">
            {examData.conditions[region]?.[condition]?.R ? (
              <CheckIcon />
            ) : (
              ""
            )}
          </td>
          <td className="border px-2 py-1 text-center">
            {examData.conditions[region]?.[condition]?.L ? (
              <CheckIcon />
            ) : (
              ""
            )}
          </td>
        </React.Fragment>
      ))}
    </tr>
  ))}
</tbody>
  </table>
</div>


{/* Technician's Comments Section */}
<div className="mt-4">
  <h6 className="text-start text-xl font-semibold mb-2">
    {allowedUsers.includes(examData?.createdby) ? (
      <div>IMPRESSIONS</div>
    ) : (
      <div>TECHNICIAN'S CONCLUSIONS AND COMMENTS</div>
    )}
    </h6>
  <div className="space-y-4">
    {examData?.technicianComments?.map((field, index) => (
      <div key={index} className="flex pt-2">
        {/* Render the comment's value */}
        <span className="text-start font-medium text-gray-700 w-full">
          <p>{field?.value}</p>
        </span>
      </div>
    ))}
  </div>
</div>


        {examData ? (
                  <>
            <div className="py-8">
              <div className="flex justify-between items-center">
                <div>
                    {examData?.signoff && (
                      <>
                        <img src={DrMadhuSign} alt="Signed Off" className="ml-2 h-20 inline-block" />
                        <div className="font-semibold">Dr. Madhu Pamganamamula MD FACP FASPC DABOM DABCL CCD</div>
                      </>
                    )}
                </div>
              </div>
            </div>
        </>
        ) : (
         <></>
        )}


          </>
        ) : (
          <p className="text-center text-gray-500">Loading...</p>
        )}
      </div>
    </div>
  );
};

export default VenousView;